import React from 'react';
import Icon from '../../common/icons';
import annaAvatar from '../../../assets/Anna_Chat_Avatar.png';
import { pick } from './configs/common';

/**
 * "Working out your result…": what happens between the last answer and the result (counted the
 * answers, finding programs, saving), with the bar at the real step. `slow` after a long wait,
 * `trouble` ('offline' | 'server') while the connection is the problem. A card in the chat on a
 * computer; the whole screen on a phone (TestChat decides).
 */
const WorkingCard = ({ working, step, slow, trouble, lang = 'en' }) => {
  const steps = working.steps || [];
  const at = Math.max(0, steps.findIndex((s) => s.key === step));
  const width = steps.length ? Math.round(((at + 0.5) / steps.length) * 100) : 50;
  let note = null;
  if (trouble === 'offline') note = lang === 'fil' ? 'Hinihintay ang koneksyon mo…' : 'Waiting for your connection…';
  else if (trouble) note = lang === 'fil' ? 'Abala ang server. Sinusubukan ulit…' : 'The server is busy. Trying again…';
  else if (slow && working.slow) note = pick(working.slow, lang);
  return (
    <div className="ts-working" role="status" aria-live="polite">
      <span className="ts-working-av">
        <img src={annaAvatar} alt="" />
        <i aria-hidden="true" />
      </span>
      <strong className="ts-working-title">{pick(working.title, lang)}</strong>
      <span className="ts-working-bar" aria-hidden="true">
        <i style={{ width: `${width}%` }} />
      </span>
      <ul className="ts-working-steps">
        {steps.map((s, i) => {
          const state = i < at ? 'done' : i === at ? 'now' : 'todo';
          return (
            <li key={s.key} className={`is-${state}`}>
              {state === 'done' ? <Icon name="check" size={14} /> : <span className="ts-working-dot" aria-hidden="true" />}
              <span>{pick(s.text, lang)}</span>
            </li>
          );
        })}
      </ul>
      {note && <p className="ts-working-note">{note}</p>}
    </div>
  );
};

export default WorkingCard;
